import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { logoutAction } from "../../actions/LoginAction";
import AppoinmentHistory from "../AppoinmentHistory/DoctorAppointmentHistory";
import TermsandConditions from "../TermsandConditions";
import DoctorDashboardComponent from "./Components/DoctorDasboardComponent/DoctorDashboardComponent";
import styles from "./dashboardv2.module.scss";
import {
  fetch_clientDetails,
  getCountryData,
} from "../../actions/MicrositeAction";
import {
  fetchAppointmentHistory,
  fetchSelectedAppointmentDetails,
} from "../../actions/AppointmentActions";
import { createContext } from "react";
import DashboardNavbar from "../DashboardNavbar/DashboardNavbar";
import { DashboardNavIcon, NavIcons } from "../../assets/NavbarIcons/NavIcons";
import DashboardAvatar from "../DashboardAvatar/DashboardAvatar";
import { ThemeList, getTheme } from "../../config/theme.config";
import { HamburgerIcon } from "../../assets/Logos/Icons";
import FaqContent from "../FAQ/FaqContent";
import mainlogo from "../../assets/Logos/c2mdBlue.svg";
import PrintPrescription from "../PrintPrescription/PrintPrescription";

//Contexts...............................................

export const DrDashboardContext = createContext();

function DoctorDashboardV2() {
  const dashOptions = [
    { name: "Home" },
    { name: "My Appointments" },

    // { name: "My Health profile" },
    // { name: "My Doctors" },
    // { name: "My Health files" },
    { name: "Legal" },
    { name: "CREATE_PRESCRIPTION" },
  ];
  const navData = [
    {
      options: [
        {
          name: "Home",
          ico: <DashboardNavIcon />,
        },
      ],
    },
    {
      tittle: "MY APPOINTMENTS",
      options: [
        {
          name: "Booked Appointments",
          ico: NavIcons.BookedAppointmentNavIcon(),
        },
        // {
        //   name: "My Appointment Requests",
        //   ico: NavIcons.AppointmentRequestsNavIcon(),
        // },
      ],
    },

    {
      tittle: "Help",
      options: [
        {
          name: "FAQ",
          ico: NavIcons.Faq(),
        },
        {
          name: "Legal",
          ico: NavIcons.Privacy(),
        },
        // {
        //   isContact: true,
        //   href: "tel:+91 9876543210",
        //   name: "+91 9876543210",
        //   ico: AssetStore?.dashbaodrV2?.phone,
        // },
        // {
        //   isContact: true,
        //   href: "mailto:testemailbydeveloper@gmail.com",
        //   name: "testemailbydeveloper@gmail.com",
        //   ico: AssetStore?.dashbaodrV2?.mail,
        // },
      ],
    },
    // {
    //   options: [
    //     {
    //       name: "Prescription",
    //       ico: <DashboardNavIcon />,
    //     },
    //   ],
    // },
  ];
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const clientDetailsLocal = JSON.parse(localStorage.getItem("ClinicDetails"));

  //States..................................................
  const [activeNavItem, setActiveNavItem] = useState(() => dashOptions[0].name);
  const [activeCount, setActiveCount] = useState(1);
  const [drDashboardData, setDrDashboardData] = useState({});
  const [isDrawerOpen, setDrawerOpen] = useState();
  const [isloaded, setisloaded] = useState(false);

  const [clientDetails, setclientDetails] = useState(localStorage.getItem("ClinicDetails"));
  //Refs.......................................................
  const navContentRef = useRef();

  //Redux.....................................................

  let signupData = location.state;
  console.log("signupData", signupData);
  console.log("signupData", location.state);

  //functions...........................................................

  useEffect(() => {
    if (signupData != undefined && signupData.appointmentId != undefined) {
      if (signupData.page === "prescripton") {
        setDrDashboardData({
          appointmentId: signupData.appointmentId,
        });
        dispatch(
          fetchSelectedAppointmentDetails({
            appointmentId: signupData.appointmentId,
            
            userData,
          })
        ).then((res) => {
          console.log('fetching', res)
          //  setUploading(false)
          if(res){
           
          


          }
        });
        goToCreatePrescription(signupData.appointmentId);
        // setsignupData(null)
      }
    } else {
      setActiveNavItem(dashOptions[0].name);
    }
  }, [signupData]);

  useEffect(() => {
    const parentDiv = navContentRef.current;
    parentDiv.scrollTop = 0;
  }, [activeNavItem]);

  function getFaviconEl() {
    return document.getElementById("favicon");
  }

  useEffect(() => {
    if(!isloaded){
    dispatch(fetch_clientDetails(userData.clinicname !="" ? userData.clinicname : "")).then(
      (res) => {
        setclientDetails(res)
        setisloaded(true)
        const favicon = getFaviconEl();
        favicon.href = res?.favicon;
        document.title = res?.clinicName||"loading..";

      })
    }
  }, [userData.userId])
  function goToHistory() {
    setActiveNavItem(dashOptions[1]?.name);
    setActiveCount(0);
  }
  function goToPrescription() {
    setActiveNavItem(dashOptions[3]?.name);
    setActiveCount(0);
  }
  function handleLogout() {
    dispatch(logoutAction(userData, history));

    if (clientDetails && clientDetails.homeurl) {
      history.push("/signin");
      
    } else {
      history.push("/signin");
    }
  }
  function goToCreatePrescription(appointmentID) {
    
            setActiveNavItem("CREATE_PRESCRIPTION");
    
  }

  window.addEventListener("beforeunload", function (event) {
    // Handle the popstate event here, e.g., update the UI or revert to a previous state.
    console.log("browser refresh hit");
    history.push("/dashboard");
  });
  function handleHelpMenuClick({ option, value }) {
    switch (option) {
      case "email":
        window.location.href = `mailto:${value}`;
        break;
      case "phone":
        window.location.href = `tel:${value}`;
        break;
      case "faq":
        var url =
          window.location.protocol +
          "//" +
          window.location.host +
          process.env.PUBLIC_URL +
          "/faq";
        window.open(url, "_blank");
        break;
      default:
        break;
    }
  }

  function getActiveComponent() {
    console.log("activeNavItem", activeNavItem);
    switch (activeNavItem) {
      case "Home":
        return <DoctorDashboardComponent goToHistory={goToHistory} />;
      case "Booked Appointments":
        return (
          <AppoinmentHistory
            white={true}
            goToPrescription={goToPrescription}
            goToCreatePrescription={goToCreatePrescription}
          />
        );
      case "My Appointments":
        return (
          <AppoinmentHistory
            white={true}
            goToPrescription={goToPrescription}
            goToCreatePrescription={goToCreatePrescription}
          />
        );
      case "FAQ":
        return <FaqContent noHeader />;
      case "CREATE_PRESCRIPTION":
        return <PrintPrescription />;
      case "Legal":
        return <TermsandConditions noHeader typeId="terms" />;
      default:
        break;
    }
  }

  function getHeaderText() {
    switch (activeNavItem) {
      case "Home":
        return "My Dashboard";
      case "CREATE_PRESCRIPTION":
        return "Create/Edit Prescription";
      default:
        return activeNavItem;
    }
  }

  function handleCloseDrawer() {
    setDrawerOpen(false);
  }

  function handleOpenDrawer() {
    setDrawerOpen(true);
  }

  const getLogo = () => {
    console.log("clientDetails", clientDetails);
    if (clientDetails?.logo) {
      return clientDetails.logo;
    } else {
      return mainlogo;
    }
  };

  return (
    <DrDashboardContext.Provider
      value={{ drDashboardData, setDrDashboardData }}
    >
      {/* <div className={styles.container}>
        <div className={styles.dashboard_header}>
          <img className={styles.logo} src={Assets.logo} alt="" />

          <h1 className={styles.dashboardTitle}>{getHeaderText()}</h1>

          <div className={styles.action_container}>
            <DashboardAvatar
              handleHelpMenuClick={handleHelpMenuClick}
              handleLogout={handleLogout}
            />
          </div>
        </div>

        <div className={styles.dashboard_body}>
          <div className={styles.navbar}>
            <DashboardNavbar
              isDoctor
              theme={getTheme(ThemeList.GANGA)}
              onItemClick={setActiveNavItem}
              activeNavItem={activeNavItem}
              navData={navData}
            />
          </div>
          <div className={styles.navbar_content} ref={navContentRef}>
           
            {getActiveComponent()}
          </div>
        </div>
      </div> */}

      <div className={styles.container}>
        <div className={styles.dashboard_header}>
          <div className={styles.brandWrap}>
            <div onClick={handleOpenDrawer} className={styles.hamburgerIcon}>
              <HamburgerIcon />
            </div>
            <img
              className={styles.logo}
              src={getLogo()}
              alt=""
              onClick={(e) => {
                window.location.href = clientDetails?.clinicurl || "#";
              }}
            />
          </div>

          <h1 className={styles.dashboardTitle}>{getHeaderText()}</h1>

          <div className={styles.action_container}>
            <DashboardAvatar
              handleHelpMenuClick={handleHelpMenuClick}
              handleLogout={handleLogout}
            />
          </div>
        </div>

        <div className={styles.dashboard_body}>
          <div className={styles.navbar}>
            <DashboardNavbar
              isDrawerOpen={isDrawerOpen}
              setDrawerClose={handleCloseDrawer}
              theme={getTheme(ThemeList.GANGA)}
              onItemClick={setActiveNavItem}
              activeNavItem={activeNavItem}
              navData={navData}
              clientDetails={clientDetails}
            />
          </div>

          <div ref={navContentRef} className={styles.navbar_content}>
            {getActiveComponent()}
          </div>
        </div>
      </div>
    </DrDashboardContext.Provider>
  );
}

export default DoctorDashboardV2;
